export const CONF_SETTINGS_SUBMITTED = 'events/CONF_SETTINGS_SUBMITTED';

/**
 * @return {{type: string}}
 */
export const confSettingsSubmitted = (payload) => ({ type: CONF_SETTINGS_SUBMITTED, payload });
